const trackingId:number = parseInt(process.env.REACT_APP_HOTJAR_TRACKING_ID || "", 10) || 0;

const HotJarConfig = {
    trackingId: trackingId,
    version: 6, // Only needs to be changed when HotJar tell us.
};

export default HotJarConfig;
